"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const canvas_1 = require("canvas");
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_1 = __importDefault(require("react"));
require("./styles.css");
const canvasForMeasure = (0, canvas_1.createCanvas)(0, 0);
const fitContainer = (contentWidth, containerWidth, contentHeight, containerHeight) => contentWidth <= containerWidth && contentHeight <= containerHeight;
const getTextWidth = _ref => {
  let {
    actualBoundingBoxLeft,
    actualBoundingBoxRight
  } = _ref;
  return actualBoundingBoxLeft + actualBoundingBoxRight;
};
function FittedLabel(_ref2) {
  let {
    width,
    height,
    text,
    fontSize,
    fontFamily,
    canvas = canvasForMeasure
  } = _ref2;
  const ctx = canvas.getContext('2d');
  ctx.font = `${fontSize}px ${fontFamily}`;
  const textWidth = getTextWidth(ctx.measureText(text));
  const labelWords = text.split(' ');
  const groupWidth = (0, lodash_1.default)(labelWords).map(word => getTextWidth(ctx.measureText(word))).max();
  const groupHeight = fontSize * labelWords.length;
  const fitsHorizontally = fitContainer(textWidth, width, fontSize, height) || fitContainer(groupWidth, width, groupHeight, height);
  const fitsVertically = fitContainer(fontSize, width, textWidth, height) || fitContainer(groupHeight, width, groupWidth, height);
  const hide = !fitsHorizontally && !fitsVertically;
  return react_1.default.createElement("div", {
    className: `fitted-label ${!fitsHorizontally ? 'rotated' : ''} ${hide ? 'removed' : ''}`,
    style: {
      fontSize: `${fontSize}px`,
      width: !fitsHorizontally ? height : width
    }
  }, text);
}
FittedLabel.propTypes = {
  width: prop_types_1.number.isRequired,
  height: prop_types_1.number.isRequired,
  text: prop_types_1.string.isRequired,
  fontSize: prop_types_1.number.isRequired,
  fontFamily: prop_types_1.string.isRequired,
  canvas: (0, prop_types_1.shape)()
};
exports.default = FittedLabel;